import request from '@/router/axios'

const base = '/api/produce/railway-multi-transport-analysis'

export const fetchAnalysis = (data) =>
  request({
    url: `${base}/analyze`,
    method: 'post',
    data
  })

export const fetchDetailPage = (data) =>
  request({
    url: `${base}/detail-page`,
    method: 'post',
    data
  })

export const exportPdf = (data) =>
  request({
    url: `${base}/export-pdf`,
    method: 'post',
    data,
    responseType: 'blob'
  })
